import { useState } from "react";
import { entryChannels } from "@/mocks/home";

function statusStyle(status: string) {
  if (status === "畅通") return "bg-secondary-100 text-secondary-900";
  if (status === "稳定") return "bg-background-200 text-foreground-800";
  return "bg-accent-100 text-accent-900";
}

export default function EntryIndex() {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (address: string) => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(address);
      window.setTimeout(() => setCopied(null), 1800);
    } catch {
      setCopied(null);
    }
  };

  return (
    <section id="entries" className="w-full bg-background-100 border-y border-background-200/80">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">
              INDEX
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              入口索引 · 实时可用地址
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              以下是当前经过巡检的可用网址与链接。主站入口速度最快，备用线路与镜像地址用于兜底，移动端链接适合手机直接打开。
            </p>
          </div>
          <div className="shrink-0 rounded-lg border border-background-200 bg-background-50 px-4 py-3">
            <p className="text-xs text-foreground-500">上次巡检</p>
            <p className="mt-1 text-sm font-medium text-foreground-900">今天 09:20</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {entryChannels.map((c) => (
            <article
              key={c.name}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2">
                  <span className="rounded-md bg-primary-100 px-2 py-1 text-xs font-medium text-primary-700">
                    {c.tag}
                  </span>
                  <span
                    className={`rounded-md px-2 py-1 text-xs font-medium ${statusStyle(c.status)}`}
                  >
                    {c.status}
                  </span>
                </div>
                <span className="shrink-0 text-xs text-foreground-400">{c.latency}</span>
              </div>

              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {c.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {c.desc}
              </p>

              <div className="mt-4 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
                <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
                  <i className="ri-link-m text-sm"></i>
                </span>
                <span className="flex-1 truncate text-sm text-foreground-800 font-mono">
                  {c.address}
                </span>
                <button
                  type="button"
                  onClick={() => handleCopy(c.address)}
                  className="flex items-center gap-1 rounded-md bg-background-50 px-2.5 py-1 text-xs font-medium text-foreground-800 border border-background-300 transition-colors hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 whitespace-nowrap cursor-pointer"
                >
                  <i className={copied === c.address ? "ri-check-line" : "ri-file-copy-line"}></i>
                  {copied === c.address ? "已复制" : "复制"}
                </button>
              </div>

              <div className="mt-4 flex items-center gap-2">
                <span className="text-xs text-foreground-500">热度</span>
                <span className="h-1.5 flex-1 rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-primary-500"
                    style={{ width: `${c.heat}%` }}
                  ></span>
                </span>
                <span className="text-xs text-foreground-500">{c.heat}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}